module.exports = __webpack_public_path__ + "static/instagram-4a8c23476a7c20c5bee2a752a6f96e9e.png";